import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

import TkCustomerSupplyInputInspectionCreateDialog from "../dialogTypes/TkCustomerSupplyInputInspectionCreateDialog";
import { cloneDeep } from 'lodash';

function TkCustomerSupplyInputInspectionCreateButton(props) {

    const { t } = useTranslation();

    const { id, schema, refresh, onSuccess, createButtonName, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);

    const [tableSchema, setTableSchema] = useState();

    useEffect(() => {
        if (schema) {
            let newSchema = cloneDeep(schema)
            for (let column of newSchema.columns) {
                switch (column.name) {
                    case "inputDate":
                        column.hideInForm = false;
                        break;
                    case "wareHouseCode":
                        column.hideInForm = false;
                        column.required = true;
                        break;
                    case "inspector":
                        column.hideInForm = true;
                        break;
                    case "inspectionDate":
                        column.hideInForm = true;
                        break;
                    case "defectiveCode":
                        column.hideInForm = true;
                        break;
                    case "qcResult":
                        column.hideInForm = true;
                        break;
                    default:
                        break;
                }
            }
            setTableSchema(newSchema)
        }
    }, [schema])

    const onOpen = () => {

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={createButtonName} {...others} />
            <TkCustomerSupplyInputInspectionCreateDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${schema.name}.input`) : ""}
                schema={tableSchema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkCustomerSupplyInputInspectionCreateButton;

